import { required, email, max } from "vee-validate/dist/rules";

export const rule_required = {
  name: "required",
  options: {
    ...required,
    message: "{_field_} can not be empty"
  }
};

export const rule_required_custom = {
  name: "required_custom",
  options: {
    validate(value) {
      return {
        required: true,
        valid: ["", null, undefined, false].indexOf(value) === -1
      };
    },
    computesRequired: true,
    message: "{_field_} can not be empty"
  }
};

export const rule_email = {
  name: "email",
  options: {
    ...email,
    message: "Email must be valid"
  }
};

export const rule_max = {
  name: "max",
  options: {
    ...max,
    message: "{_field_} may not be greater than {length} characters"
  }
};

export const rule_required_other = {
  name: "required_other",
  options: {
    params: ["otherValue"],
    validate: (value, { otherValue }) => {
      if (otherValue && otherValue.length > 0) {
        return true;
      }
      return false;
    },
    computesRequired: true,
    message: "{_field_} can not be empty"
  }
};
